<div class="container">
  <div class="card-soft">

    <!-- Who Are You Traveling With -->
    <h5 class="section-heading mb-4">Who Are You Traveling With?</h5>

    <div class="travel-type-buttons mb-4" id="passengerSection">
      <button
        class="travel-type-btn"
        [class.active]="passengers.type==='personal'"
        (click)="chooseType('personal')">
        <i class="fa-solid fa-user"></i>
        <span>Personal</span>
      </button>

      <button
        class="travel-type-btn"
        [class.active]="passengers.type==='corporate'"
        (click)="chooseType('corporate')">
        <span class="material-symbols-outlined">lock_person</span>
        <span>Corporate</span>
      </button>
    </div>

    <!-- Passenger Type Error -->
    <div *ngIf="error.type" class="text-danger small text-center mb-3">
      Please select who you are travelling with.
    </div>

    <!-- Passenger Counter Section -->
    <div class="passenger-counters mb-4">

      <!-- Adults -->
      <div class="counter-group">
        <label class="counter-label">Adults</label>
        <div class="counter-controls">
          <button type="button" class="counter-btn" (click)="changeAdults(-1)">
            <i class="fa-solid fa-minus"></i>
          </button>
          <span class="counter-value">{{ passengers.adults }}</span>
          <button type="button" class="counter-btn" (click)="changeAdults(1)">
            <i class="fa-solid fa-plus"></i>
          </button>
        </div>
        <div *ngIf="error.adults" class="text-danger small mt-1">
          Please enter at least 1 adult.
        </div>
      </div>

      <!-- Children -->
      <div class="counter-group">
        <label class="counter-label">Children (above 10)</label>
        <div class="counter-controls">
          <button type="button" class="counter-btn" (click)="changeChildren(-1)">
            <i class="fa-solid fa-minus"></i>
          </button>
          <span class="counter-value">{{ passengers.children }}</span>
          <button type="button" class="counter-btn" (click)="changeChildren(1)">
            <i class="fa-solid fa-plus"></i>
          </button>
        </div>
        <div *ngIf="error.children" class="text-danger small mt-1">
          Children cannot be negative.
        </div>
      </div>

      <!-- Luggage -->
      <div class="counter-group">
        <label class="counter-label">Luggage</label>
        <div class="counter-controls">
          <button type="button" class="counter-btn" (click)="changeLuggage(-1)">
            <i class="fa-solid fa-minus"></i>
          </button>
          <span class="counter-value">{{ passengers.luggage }}</span>
          <button type="button" class="counter-btn" (click)="changeLuggage(1)">
            <i class="fa-solid fa-plus"></i>
          </button>
        </div>
        <div *ngIf="error.luggage" class="text-danger small mt-1">
          Please enter valid luggage count.
        </div>
      </div>

    </div>

    <!-- Selected Vehicle Preview -->
    <div *ngIf="selectedVehicle" class="mb-4">
      <div class="selected-header">
        <h6 class="selected-title">Your Selected Ride</h6>
        <span class="best-match-badge">Best Match</span>
      </div>

      <div class="selected-vehicle-card">
        <div class="vehicle-badge">Selected</div>
        <div class="vehicle-content">
          <img [src]="selectedVehicle.image" class="vehicle-image" alt="{{ selectedVehicle.name }}" />

          <div class="vehicle-details">
            <div class="vehicle-name">{{ selectedVehicle.name }}</div>
            <div class="vehicle-specs">{{ selectedVehicle.seats }} Seats • {{ selectedVehicle.bags }} Bags • {{ selectedVehicle.fuel }}</div>
            <div class="vehicle-model">{{ selectedVehicle.description || 'Hyundai Aura, Dzire, or Similar' }}</div>

            <div class="vehicle-features">
              <span class="feature-item">
                <i class="fa-solid fa-wind"></i> AC
              </span>
              <span class="feature-item">
                <i class="fa-solid fa-music"></i> Music System
              </span>
              <span class="feature-item">
                <i class="fa-solid fa-shield-halved"></i> Verified Driver
              </span>
              <span class="feature-item">
                <i class="fa-solid fa-gas-pump"></i> Fuel Included
              </span>
            </div>
          </div>

          <div class="vehicle-price-section">
            <div class="vehicle-price">₹{{ selectedVehicle.price | number:'1.2-2' }}
              <br/>
              <div class="price-label">Estimated fare</div>
            </div>

            <button class="breakdown-btn" (click)="showBreakdown = true">View Breakdown</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Vehicle Error -->
    <div *ngIf="error.vehicle" class="text-danger small mb-2">
      Please select a vehicle.
    </div>

    <!-- Explore Other Options (All other cars except selected) -->
    <div *ngIf="otherCars.length > 0">
      <h6 class="explore-heading" id="vehicleSection">EXPLORE OTHER OPTIONS</h6>

      <div class="vehicles-grid">
        <!-- All cars except the selected one -->
        <div class="vehicle-option-card"
          *ngFor="let car of otherCars"
          (click)="selectVehicle(car)"
          [class.selected]="selectedVehicleId === car.id">

          <!-- Show upgrade badge only for cars from other categories -->
          <div class="upgrade-badge" *ngIf="isUpgradeCar(car)">Upgrade</div>

          <div class="option-content">
            <img [src]="car.image" class="option-image" alt="{{ car.name }}" />

            <div class="option-details">
              <div class="option-name">{{ car.name }}</div>
              <div class="option-specs">{{ car.seats }} Seats • {{ car.bags }} Bags</div>
            </div>

            <div class="option-price-section">
              <div class="option-price">₹{{ car.price | number:'1.2-2' }}</div>
              <div class="option-price-label">Est. fare</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation -->
    <div class="navigation-buttons">
      <button class="btn-back" (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i> Go Back
      </button>
      <button class="btn-next" [class.disabled-looking]="!isFormValid()" (click)="next()">
        Next: Booking Summary <i class="fa-solid fa-arrow-right"></i>
      </button>
    </div>

  </div>
</div>

<div class="modal-overlay"
     *ngIf="showBreakdown && selectedVehicle?.fareQuote as fare"
     (click)="showBreakdown = false">

  <div class="breakdown-modal" (click)="$event.stopPropagation()">
    <button class="modal-close" (click)="showBreakdown = false">
      <i class="fa-solid fa-xmark"></i>
    </button>

    <h5 class="modal-title">
      Fare Breakdown for {{ selectedVehicle?.name }}
    </h5>

<div class="breakdown-items">

  <!-- ================= PICKUP & DROP ================= -->
  <ng-container *ngIf="fare.tripType === 'pickup_drop'">

    <div class="breakdown-item">
      <span class="item-label">
        Base Fare
        <small>(Includes {{ fare.meta?.baseKm || 4 }} km)</small>
      </span>
      <span class="item-value">
        ₹{{ fare.lines[0]?.amount | number:'1.2-2' }}
      </span>
    </div>

    <div class="breakdown-item" *ngFor="let line of fare.lines"
         [hidden]="line.code !== 'EXTRA_KM'">
      <span class="item-label">
        Extra Distance
        <small>({{ line.qty | number:'1.2-2' }} km × ₹{{ line.unitPrice | number:'1.2-2' }})</small>
      </span>
      <span class="item-value">
        ₹{{ line.amount | number:'1.2-2' }}
      </span>
    </div>

  </ng-container>

  <!-- ================= RENTAL ================= -->
  <ng-container *ngIf="fare.tripType === 'rental'">

    <div class="breakdown-item">
      <span class="item-label">
        Rental Package
        <small>
          ({{ fare.meta?.packageHours || 8 }} hrs /
          {{ fare.meta?.packageKm || 80 }} km)
        </small>
      </span>
      <span class="item-value">
        ₹{{ fare.lines[0]?.amount | number:'1.2-2' }}
      </span>
    </div>

    <div class="breakdown-item" *ngFor="let line of fare.lines"
         [hidden]="line.code !== 'EXTRA_KM'">
      <span class="item-label">
        Extra Distance
        <small>({{ line.qty }} km × ₹{{ line.unitPrice | number:'1.2-2' }})</small>
      </span>
      <span class="item-value">
        ₹{{ line.amount | number:'1.2-2' }}
      </span>
    </div>

    <div class="breakdown-item" *ngFor="let line of fare.lines"
         [hidden]="line.code !== 'EXTRA_HOUR'">
      <span class="item-label">
        Extra Time
        <small>({{ line.qty| number:'1.2-2' }} hrs × ₹{{ line.unitPrice | number:'1.2-2' }})</small>
      </span>
      <span class="item-value">
        ₹{{ line.amount | number:'1.2-2' }}
      </span>
    </div>

  </ng-container>

<!-- ================= OUTSTATION ================= -->
<ng-container *ngIf="fare.tripType === 'outstation'">

  <!-- Rule explanation -->
  <div class="breakdown-item text-muted">
    <span class="item-label">
      Minimum distance per day rule applies
    </span>
  </div>

  <!-- Actual distance -->
  <div class="breakdown-item">
    <span class="item-label">
      Actual Distance
    </span>
    <span class="item-value">
      {{ fare.distanceKm | number:'1.2-2' }} km
    </span>
  </div>

  <!-- Billable distance explanation -->
  <div class="breakdown-item">
    <span class="item-label">
      Billable Distance
      <small>
        (Higher of actual distance <br/> or minimum distance per day)
      </small>
    </span>
    <span class="item-value">
      {{ fare.lines[0]?.qty | number:'1.2-2' }} km
    </span>
  </div>

  <!-- Distance charge -->
  <div class="breakdown-item">
    <span class="item-label">
      Distance Charge
      <small>
        ({{ fare.lines[0]?.qty | number:'1.2-2' }} km ×
        ₹{{ fare.lines[0]?.unitPrice | number:'1.2-2' }})
      </small>
    </span>
    <span class="item-value">
      ₹{{ fare.lines[0]?.amount | number:'1.2-2' }}
    </span>
  </div>

  <!-- Driver allowance -->
  <div class="breakdown-item">
    <span class="item-label">
      Driver Allowance
      <small>
        ({{ fare.lines[1]?.qty }} day ×
        ₹{{ fare.lines[1]?.unitPrice | number:'1.2-2' }})
      </small>
    </span>
    <span class="item-value">
      ₹{{ fare.lines[1]?.amount | number:'1.2-2' }}
    </span>
  </div>

</ng-container>


</div>

<div class="breakdown-total">
  <span class="total-label">Total Estimated Fare</span>
  <span class="total-value">
    ₹{{ fare.total | number:'1.2-2' }}
  </span>
</div>

<div class="breakdown-note">
  <strong>Note:</strong>
  Fare is estimated and may vary based on actual distance, duration, tolls, or waiting time.
</div>

  </div>
</div>




